import React, { Fragment, useContext, useEffect } from "react";
import Login from "../components/auth/Login";
import FundWallet from "../components/dashboard/FundWallet";
import { CartContext } from "../util/context";
import { useNavigate } from "react-router-dom";
import { inactiveState } from "../util/inactivity";

export default function FundWalletPage() {
  const ctx = useContext(CartContext);
  const navigate = useNavigate();

  window.onload = function () {
    inactiveState(ctx, navigate);
  };

  useEffect(() => {
    if (!ctx.isLoggedIn) {
      navigate("/login");
    }
  }, [ctx]);
  return <FundWallet />;
}
